import { render, staticRenderFns } from "./DropdownCategories.vue?vue&type=template&id=2975953e&"
import script from "./DropdownCategories.vue?vue&type=script&lang=js&"
export * from "./DropdownCategories.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCategories.vue?vue&type=style&index=0&id=2975953e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports